import * as React from 'react'
import type { SVGProps } from 'react'
const SvgFacebookMessenger = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 11.7C2 6.1274 6.3684 2 12 2s10 4.1295 10 9.7021-4.3684 9.7-10 9.7c-1.0126 0-1.9821-.1347-2.8947-.3842a.805.805 0 0 0-.5348.04l-1.9852.8737a.8.8 0 0 1-.7495-.0544.8.8 0 0 1-.3737-.6519l-.0547-1.78a.79.79 0 0 0-.2674-.5706C3.1947 17.1347 2 14.6147 2 11.7m6.9326-1.8221-2.9368 4.66c-.2842.4474.2663.9495.6863.6295l3.1558-2.3948a.6.6 0 0 1 .7221-.0021l2.3368 1.7516a1.5 1.5 0 0 0 1.173.276 1.501 1.501 0 0 0 .9976-.676l2.94-4.6568c.28-.4474-.2695-.9527-.6895-.6327l-3.1558 2.3948a.6.6 0 0 1-.7221.0021l-2.3368-1.7516a1.502 1.502 0 0 0-1.173-.2755 1.5 1.5 0 0 0-.9976.6755"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgFacebookMessenger
